import Sidebar from "../Sidebar/Sidebar";
import Navbar from "../Navbar/Navbar";
import React, { useState, useEffect, useRef, useCallback } from "react";
import "../Assets/Css/Table.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import GlobalDataTable from "../components/GlobalDataTable";
import { Alert, Form } from "react-bootstrap";
import { axiosConfig } from "../axiosAPI";
import Swal from "sweetalert2";
import { useAuth } from "../AuthProvider";
import { useSearchParams, useNavigate } from "react-router-dom";
// import { Formik, Form, Field } from "formik";
import { InputSwitch } from "primereact/inputswitch";
import { FaTrash } from "react-icons/fa";

function User() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const auth = useAuth();
  const passengersTableRef = useRef(null);

  const [breeds, setBreeds] = useState([]);

  const defaultRowCount = 10;
  const rowCountOptions = [10, 20, 50, 100];
  const pageNoFromUrl = Math.max(1, parseInt(searchParams.get("pageNo") || "1", 10) || 1);
  const rowCountFromUrl = (() => {
    const n = parseInt(searchParams.get("rowCount") || String(defaultRowCount), 10) || defaultRowCount;
    return rowCountOptions.includes(n) ? n : defaultRowCount;
  })();
  const keywordFromUrl = searchParams.get("keyword") || "";
  const initialFirst = (pageNoFromUrl - 1) * rowCountFromUrl;

  const buildPassengerListPath = useCallback(() => {
    const state = passengersTableRef.current?.getState?.();
    const params = new URLSearchParams();
    const pageNo = state?.pageNo ?? pageNoFromUrl;
    const rows = state?.rows ?? rowCountFromUrl;
    const keyword = state?.keyword ?? keywordFromUrl;
    if (pageNo > 1) params.set("pageNo", String(pageNo));
    if (rows !== defaultRowCount) params.set("rowCount", String(rows));
    if (keyword) params.set("keyword", keyword);
    const query = params.toString();
    return query ? `/User?${query}` : "/User";
  }, [pageNoFromUrl, rowCountFromUrl, keywordFromUrl]);

  const handleTableStateChange = useCallback(
    ({ pageNo, rows, keyword }) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams();
          if (pageNo > 1) next.set("pageNo", String(pageNo));
          if (rows !== defaultRowCount) next.set("rowCount", String(rows));
          if (keyword) next.set("keyword", keyword);
          if (prev.toString() === next.toString()) return prev;
          return next;
        },
        { replace: true }
      );
    },
    [setSearchParams]
  );

  const fetchPassengersPage = useCallback(
    async ({ pageNo, rowCount, keyword }) => {
      try {
        const params = new URLSearchParams({
          pageNo: String(pageNo),
          rowCount: String(rowCount),
        });
        if (keyword) params.set("keyword", keyword);
        const response = await axiosConfig.get(
          `${process.env.REACT_APP_BASE_URL}/users/passengers?${params.toString()}`,
          {
            headers: {
              Authorization: "Bearer " + auth.token,
              "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
            },
          }
        );
        return {
          result: response.data.data.result,
          totalCount: response.data.data.totalCount,
        };
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
        });
        return { result: [], totalCount: 0 };
      }
    },
    [auth.token]
  );

  const getBreeds = async () => {
    try {
      const response = await axiosConfig.get(`${process.env.REACT_APP_BASE_URL}/dog-breeds`, {
        headers: {
          Authorization: "Bearer " + auth.token,
          "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
        },
      });
      setBreeds(response.data.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong loading breeds!",
      });
    }
  };

  const pendingCount = customers.filter(
    (customer) => customer.stateLocalized?.toLowerCase() === "disabled"
  ).length;

  const userToolbarExtras = (
    <>
      <div className="search-item">
        <label htmlFor="customerSelect" className="search-label">
          <i className="fa fa-user me-1"></i>
          Select User:
        </label>
        <Dropdown
          id="customerSelect"
          value={selectedCustomer}
          onChange={(e) => {
            const v = e.value;
            setSelectedCustomer(v);
            passengersTableRef.current?.setSearch(v ? v.phoneNumber || v.fullName || "" : "");
          }}
          options={customers}
          optionLabel="fullName"
          placeholder="Search and select a user"
          filter
          filterPlaceholder="Search users..."
          showClear
          className="custom-dropdown"
          itemTemplate={(option) =>
            option ? (
              <div className="dropdown-item">
                <div className="dropdown-content">
                  <div className="dropdown-name">{option.fullName || "Unknown User"}</div>
                  <div className="dropdown-details">{option.phoneNumber || "N/A"}</div>
                </div>
              </div>
            ) : (
              <span>No user selected</span>
            )
          }
          valueTemplate={(option) =>
            option ? (
              <div className="selected-value">
                <span className="selected-text">{option.fullName}</span>
              </div>
            ) : (
              <span className="placeholder-text">Select a user</span>
            )
          }
        />
      </div>
      <div className="search-item">
        <div className="pending-count-label">
          <i className="fa fa-user-times me-1"></i>
          <span className="pending-text">Disabled on page:</span>
          <span className="pending-count">{pendingCount}</span>
        </div>
      </div>
    </>
  );

  useEffect(() => {
    getBreeds();
  }, [auth.token]);

  const [visible, setVisible] = useState(false);
  const [visible2, setVisible2] = useState(false);

  const headerElement2 = (
    <div className="inline-flex align-items-center justify-content-center gap-2">
      <span className="font-bold white-space-nowrap">Edit User</span>
    </div>
  );

  const headerElement = (
    <div className="inline-flex align-items-center justify-content-center gap-2">
      <span className="font-bold white-space-nowrap">Add User</span>
    </div>
  );

  const footerContent = (
    <div className="modal-button">
      <Button label="Cancel" className="cancel" onClick={() => setVisible(false)} autoFocus />
      <Button
        label="Save"
        type="submit"
        onClick={() => {
          handleSubmit();
          setVisible(false);
        }}
        className="save"
        autoFocus
      />
    </div>
  );

  const footerContent2 = (
    <div className="modal-button">
      <Button label="Cancel" className="cancel" onClick={() => setVisible2(false)} autoFocus />
      <Button
        label="Save"
        type="submit"
        onClick={() => {
          editUser();
          setVisible2(false);
        }}
        className="save"
        autoFocus
      />
    </div>
  );

  const [formData, setFormData] = useState({
    PhoneNumber: "",
    FullName: "",
    Password: "",
    CarPlateNumber: "",
    CarColor: "",
    Dogs: [
      {
        name: "",
        age: 0,
        weight: 0,
        gender: "Male",
        breedUuid: "",
        license: "",
      },
    ],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.files[0] });
  };

  const handleDogChange = (index, e) => {
    const { name, value } = e.target;
    const newDogs = [...formData.Dogs];
    newDogs[index] = { ...newDogs[index], [name]: value };
    setFormData({ ...formData, Dogs: newDogs });
  };

  const handleDogFileChange = (index, e) => {
    const newDogs = [...formData.Dogs];
    newDogs[index] = {
      ...newDogs[index],
      photoFile: e.target.files[0],
    };
    setFormData({ ...formData, Dogs: newDogs });
  };

  const handleSubmit = async (e) => {
    // e.preventDefault();
    console.log(formData);
    // const response = await axiosConfig
    //   .post("https://app.dogdriveapp.com/api/v2/users/passengers/create", formData, {
    //     headers: {
    //       Authorization: "Bearer " + auth.token,
    //       "Content-Type": "multipart/form-data",
    //       "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
    //     },
    //   })
    //   .then((res) => {
    //     getData();
    //   })
    //   .catch((error) => {
    //     Swal.fire({
    //       icon: "error",
    //       title: "Oops...",
    //       text: "Something went wrong!",
    //     });
    //   });
    // setFormData("");
  };

  const [items, setItems] = useState([]);
  const addItemToList = () => {
    // list.push(listItem);
    // setItems((listItem) => [...listItem, list]);
  };

  const [indexRow, setIndexRow] = useState(false);

  const handleItemClick = (selectedIndex) => {
    // The magic of onClick - updating the selected item and visual cues!
    setIndexRow(selectedIndex);
  };

  const blockUser = async (uuid) => {
    try {
      await axiosConfig.put(
        `${process.env.REACT_APP_BASE_URL}/users/${uuid}/block`,
        {},
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      passengersTableRef.current?.reload();
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "User blocked successfully!",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to block user!",
      });
    }
  };

  const unBlockUser = async (uuid) => {
    try {
      await axiosConfig.put(
        `${process.env.REACT_APP_BASE_URL}/users/${uuid}/unblock`,
        {},
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "application/json",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      passengersTableRef.current?.reload();
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "User unblocked successfully!",
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to unblock user!",
      });
    }
  };

  const editUser = async () => {
    console.log(formData);

    try {
      const response = await axiosConfig.put(
        `${process.env.REACT_APP_BASE_URL}/users/passengers/${formData.uuid}/update`,
        formData,
        {
          headers: {
            Authorization: "Bearer " + auth.token,
            "Content-Type": "multipart/form-data",
            "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
          },
        }
      );
      passengersTableRef.current?.reload();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  const statusAction = (rowData) => {
    return (
      <>
        <div className="action-table">
          <a
            className="view"
            title="View profile"
            onClick={() => {
              navigate(`/PassengerDetails/${rowData.uuid}`, {
                state: { item: rowData, returnTo: buildPassengerListPath() },
              });
            }}
          >
            <i className="fa fa-eye"></i>
          </a>
          <a
            className="edit"
            title="Edit user"
            onClick={(e) => {
              const editData = {
                uuid: rowData.uuid,
                FullName: rowData.fullName,
                PhoneNumber: rowData.phoneNumber,
                Dogs: rowData.dogs
                  ? rowData.dogs.map((dog) => ({
                      uuid: dog.uuid,
                      name: dog.name,
                      age: dog.age,
                      weight: dog.weight,
                      gender: dog.gender,
                      breedUuid: dog.breedUuid,
                      license: dog.license,
                    }))
                  : [],
              };
              setFormData(editData);
              setVisible2(true);
            }}
          >
            <i className="fa fa-pen"></i>
          </a>
          {rowData.stateLocalized == "Enabled" ? (
            <a
              className="delete"
              onClick={(e) => {
                blockUser(rowData.uuid);
              }}
            >
              <i className="fa fa-ban"></i>
            </a>
          ) : (
            <a
              className="delete"
              onClick={(e) => {
                unBlockUser(rowData.uuid);
              }}
            >
              <i className="fa fa-unlock"></i>
            </a>
          )}
        </div>
      </>
    );
  };

  const addDog = (e) => {
    // Prevent the default form submission
    e.preventDefault();

    setFormData({
      ...formData,
      Dogs: [
        ...formData.Dogs,
        {
          name: "",
          age: 0,
          weight: 0,
          gender: "Male",
          breedUuid: "",
          license: "",
        },
      ],
    });
  };

  // Update the deleteDog function
  const deleteDog = async (e, dogUuid) => {
    // Prevent the default form submission
    e.preventDefault();

    try {
      await axiosConfig.delete(`${process.env.REACT_APP_BASE_URL}/users/passengers/dogs/${dogUuid}`, {
        headers: {
          Authorization: "Bearer " + auth.token,
          "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
        },
      });
      // After successful deletion, update the local state
      const newDogs = formData.Dogs.filter((dog) => dog.uuid !== dogUuid);
      setFormData({ ...formData, Dogs: newDogs });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Something went wrong!",
      });
    }
  };

  const handleDogRowUpdate = async (dog) => {
    if (!dog.uuid) return; // Skip if this is a new dog

    try {
      const formData = new FormData();
      formData.append("name", dog.name);
      formData.append("age", dog.age);
      formData.append("weight", dog.weight);
      formData.append("gender", dog.gender);
      formData.append("breedUuid", dog.breedUuid);
      formData.append("license", dog.license);
      if (dog.photoFile instanceof File) {
        formData.append("photoFile", dog.photoFile);
      }

      await axiosConfig.put(`${process.env.REACT_APP_BASE_URL}/users/passengers/dogs/${dog.uuid}`, formData, {
        headers: {
          Authorization: "Bearer " + auth.token,
          "Content-Type": "multipart/form-data",
          "x-api-key": "fab6c94fc0044b53bf5e886a8fef1325",
        },
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Dog information updated successfully!",
      });

      passengersTableRef.current?.reload(); // Refresh the data
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Failed to update dog information!",
      });
    }
  };

  return (
    <>
      <div className="main">
        <div className="sidebar">
          <Sidebar />
        </div>
        <div className="dev-table">
          <Navbar />
          <div className="table-card">
            <div className="table">
              <a className="add" onClick={() => setVisible(true)}>
                <i className="fa fa-plus"></i>
              </a>
              <GlobalDataTable
                ref={passengersTableRef}
                fetchPage={fetchPassengersPage}
                defaultRowCount={defaultRowCount}
                rowCountOptions={rowCountOptions}
                initialFirst={initialFirst}
                initialRows={rowCountFromUrl}
                initialSearch={keywordFromUrl}
                onTableStateChange={handleTableStateChange}
                searchPlaceholder="Search by name, phone, or other fields..."
                emptyMessage="No customers found."
                headerTitle={
                  <span>
                    <i className="fa fa-users me-2"></i>
                    User Management
                  </span>
                }
                toolbarExtras={userToolbarExtras}
                onRowsChange={setCustomers}
                dataKey="uuid"
                showGridlines
                tableStyle={{ minWidth: "700px" }}
              >
                <Column field="fullName" header="user name" style={{ width: "16.66666666%" }}></Column>
                <Column field="phoneNumber" header="phone number" style={{ width: "16.66666666%" }}></Column>
                <Column field="dateCreated" header="date Join" style={{ width: "16.66666666%" }}></Column>
                <Column field="dateLastLogin" header="date Last Login" style={{ width: "16.66666666%" }}></Column>
                <Column field="stateLocalized" header="state" style={{ width: "16.66666666%" }}></Column>
                <Column header="" style={{ width: "16.66666666%" }} field="uuid" body={statusAction}></Column>
              </GlobalDataTable>
              <Dialog
                visible={visible}
                modal
                header={headerElement}
                footer={footerContent}
                style={{ width: "90%" }}
                onHide={() => {
                  if (!visible) return;
                  setVisible(false);
                }}
              >
                <Form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="FullName"
                          placeholder="Saqer"
                          value={formData.FullName}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          type="tel"
                          name="PhoneNumber"
                          placeholder="01143987449"
                          value={formData.PhoneNumber}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>password</Form.Label>
                        <Form.Control
                          type="password"
                          name="Password"
                          placeholder="****"
                          value={formData.Password}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-12">
                      <h4 className="mt-4 mb-3">Dogs Information</h4>
                      <DataTable value={formData.Dogs} className="mt-3">
                        <Column
                          field="name"
                          header="Name"
                          body={(rowData, rowIndex) => (
                            <InputText
                              value={rowData.name}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "name", value: e.target.value },
                                })
                              }
                              placeholder="Enter dog name"
                            />
                          )}
                        />
                        <Column
                          field="age"
                          header="Age"
                          body={(rowData, rowIndex) => (
                            <InputText
                              type="number"
                              value={rowData.age}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "age", value: parseInt(e.target.value) || 0 },
                                })
                              }
                              placeholder="Age"
                            />
                          )}
                        />
                        <Column
                          field="weight"
                          header="Weight"
                          body={(rowData, rowIndex) => (
                            <InputText
                              type="number"
                              value={rowData.weight}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "weight", value: parseFloat(e.target.value) || 0 },
                                })
                              }
                              placeholder="Weight"
                            />
                          )}
                        />
                        <Column
                          field="license"
                          header="License"
                          body={(rowData, rowIndex) => (
                            <InputText
                              value={rowData.license}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "license", value: e.target.value },
                                })
                              }
                              placeholder="License number"
                            />
                          )}
                        />
                        <Column
                          field="gender"
                          header="Gender"
                          body={(rowData, rowIndex) => (
                            <select
                              value={rowData.gender}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "gender", value: e.target.value },
                                })
                              }
                              className="p-inputtext"
                            >
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                          )}
                        />
                        <Column
                          field="breedUuid"
                          header="Breed"
                          body={(rowData, rowIndex) => (
                            <select
                              value={rowData.breedUuid}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "breedUuid", value: e.target.value },
                                })
                              }
                              className="p-inputtext"
                            >
                              <option value="">Select Breed</option>
                              {breeds.map((breed) => (
                                <option key={breed.uuid} value={breed.uuid}>
                                  {breed.displayName}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                        <Column
                          field="photoFile"
                          header="Photo"
                          body={(rowData, rowIndex) => (
                            <div>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleDogFileChange(rowIndex.rowIndex, {
                                    target: { name: "photoFile", files: e.target.files },
                                  })
                                }
                                style={{ display: "none" }}
                                id={`photo-upload-${rowIndex.rowIndex}`}
                              />
                              <label htmlFor={`photo-upload-${rowIndex.rowIndex}`} className="p-button p-button-outlined">
                                {rowData.photoFile ? "Change Photo" : "Upload Photo"}
                              </label>
                              {rowData.photoFile && <span className="ml-2">{rowData.photoFile.name}</span>}
                            </div>
                          )}
                        />
                        <Column
                          body={(rowData) => (
                            <Button
                              icon="pi pi-save"
                              className="p-button-success"
                              type="button"
                              disabled={!rowData.uuid} // Disable for new dogs
                              onClick={() => handleDogRowUpdate(rowData)}
                              // tooltip="Save dog changes"
                            >
                              <i className="fa fa-save" style={{ color: "green" }}></i>
                            </Button>
                          )}
                        />
                        <Column
                          body={(rowData, rowIndex) => (
                            <Button
                              icon="pi pi-trash"
                              className="p-button-danger"
                              type="button"
                              onClick={(e) => {
                                // Only call the API if the dog has a UUID (existing dog)
                                if (rowData.uuid) {
                                  deleteDog(e, rowData.uuid);
                                } else {
                                  // For newly added dogs (without UUID), just remove from state
                                  e.preventDefault();
                                  const newDogs = formData.Dogs.filter((_, idx) => idx !== rowIndex.rowIndex);
                                  setFormData({ ...formData, Dogs: newDogs });
                                }
                              }}
                            >
                              <i className="fa fa-trash"></i>
                            </Button>
                          )}
                        />
                      </DataTable>
                      <button
                        label="Add Dog"
                        // className="p-button-secondary mt-2"
                        onClick={addDog}
                        type="button"
                        style={{ backgroundColor: "#E23904", color: "white", borderRadius: "5px", marginTop: "10px", border: "none" }}
                      >
                        + Add Dog
                      </button>
                    </div>
                  </div>
                </Form>
              </Dialog>
              <Dialog
                visible={visible2}
                modal
                header={headerElement2}
                footer={footerContent2}
                style={{ width: "90%" }}
                onHide={() => {
                  if (!visible2) return;
                  setVisible2(false);
                }}
              >
                <Form onSubmit={editUser}>
                  <div className="row">
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="FullName"
                          placeholder="Saqer"
                          value={formData.FullName}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          type="tel"
                          name="PhoneNumber"
                          placeholder="01143987449"
                          value={formData.PhoneNumber}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    <div className="col-md-6">
                      <Form.Group className="form-group">
                        <Form.Label>password</Form.Label>
                        <Form.Control
                          type="password"
                          name="Password"
                          placeholder="****"
                          value={formData.Password}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </div>
                    {/* dogs information */}
                    <div className="col-md-12">
                      <h4 className="mt-4 mb-3">Dogs Information</h4>
                      <DataTable value={formData.Dogs} className="mt-3">
                        <Column
                          field="name"
                          header="Name"
                          body={(rowData, rowIndex) => (
                            <InputText
                              value={rowData.name}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "name", value: e.target.value },
                                })
                              }
                              placeholder="Enter dog name"
                            />
                          )}
                        />
                        <Column
                          field="age"
                          header="Age"
                          body={(rowData, rowIndex) => (
                            <InputText
                              type="number"
                              value={rowData.age}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "age", value: parseInt(e.target.value) || 0 },
                                })
                              }
                              placeholder="Age"
                            />
                          )}
                        />
                        <Column
                          field="weight"
                          header="Weight"
                          body={(rowData, rowIndex) => (
                            <InputText
                              type="number"
                              value={rowData.weight}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "weight", value: parseFloat(e.target.value) || 0 },
                                })
                              }
                              placeholder="Weight"
                            />
                          )}
                        />
                        <Column
                          field="license"
                          header="License"
                          body={(rowData, rowIndex) => (
                            <InputText
                              value={rowData.license}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "license", value: e.target.value },
                                })
                              }
                              placeholder="License number"
                            />
                          )}
                        />
                        <Column
                          field="gender"
                          header="Gender"
                          body={(rowData, rowIndex) => (
                            <select
                              value={rowData.gender}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "gender", value: e.target.value },
                                })
                              }
                              className="p-inputtext"
                            >
                              <option value="Male">Male</option>
                              <option value="Female">Female</option>
                            </select>
                          )}
                        />
                        <Column
                          field="breedUuid"
                          header="Breed"
                          body={(rowData, rowIndex) => (
                            <select
                              value={rowData.breedUuid}
                              onChange={(e) =>
                                handleDogChange(rowIndex.rowIndex, {
                                  target: { name: "breedUuid", value: e.target.value },
                                })
                              }
                              className="p-inputtext"
                            >
                              <option value="">Select Breed</option>
                              {breeds.map((breed) => (
                                <option key={breed.uuid} value={breed.uuid}>
                                  {breed.displayName}
                                </option>
                              ))}
                            </select>
                          )}
                        />
                        <Column
                          field="photoFile"
                          header="Photo"
                          body={(rowData, rowIndex) => (
                            <div>
                              <input
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleDogFileChange(rowIndex.rowIndex, {
                                    target: { name: "photoFile", files: e.target.files },
                                  })
                                }
                                style={{ display: "none" }}
                                id={`photo-upload-edit-${rowIndex.rowIndex}`}
                              />
                              <label htmlFor={`photo-upload-edit-${rowIndex.rowIndex}`} className="p-button p-button-outlined">
                                {rowData.photoFile ? "Change Photo" : "Upload Photo"}
                              </label>
                              {rowData.photoFile && <span className="ml-2">{rowData.photoFile.name}</span>}
                            </div>
                          )}
                        />
                        <Column
                          body={(rowData) => (
                            <Button
                              icon="pi pi-save"
                              className="p-button-success"
                              type="button"
                              disabled={!rowData.uuid} // Disable for new dogs
                              onClick={() => handleDogRowUpdate(rowData)}
                              // tooltip="Save dog changes"
                            >
                              <i className="fa fa-save" style={{ color: "green" }}></i>
                            </Button>
                          )}
                        />
                        <Column
                          body={(rowData, rowIndex) => (
                            <button
                              // icon="pi pi-trash"
                              // className="p-button-danger"
                              type="button"
                              onClick={(e) => {
                                // Only call the API if the dog has a UUID (existing dog)
                                if (rowData.uuid) {
                                  deleteDog(e, rowData.uuid);
                                } else {
                                  // For newly added dogs (without UUID), just remove from state
                                  e.preventDefault();
                                  const newDogs = formData.Dogs.filter((_, idx) => idx !== rowIndex.rowIndex);
                                  setFormData({ ...formData, Dogs: newDogs });
                                }
                              }}
                            >
                              <FaTrash className="text-danger" />
                            </button>
                          )}
                        />
                      </DataTable>
                      <button
                        label="Add Dog"
                        // className="p-button-secondary mt-2"
                        onClick={addDog}
                        type="button"
                        style={{ backgroundColor: "#E23904", color: "white", borderRadius: "5px", marginTop: "10px", border: "none" }}
                      >
                        + Add Dog
                      </button>
                    </div>
                  </div>
                </Form>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default User;
